import { ActionCreator, on, ReducerTypes } from '@ngrx/store'

import {
  addRecommendation,
  addRecommendationFailure,
  addRecommendations,
  addRecommendationsFailure,
  addRecommendationSuccess,
  deleteRecommendation,
  deleteRecommendationError,
  deleteRecommendationSuccess,
  loadRecommendations,
  loadRecommendationsFailure,
  loadRecommendationsSuccess,
} from '../actions/recommendation.actions'
import { CropDetailActivities, cropDetailAdapter, CropDetailState } from './crop-detail.reducer'

export const recommendationOns: ReducerTypes<CropDetailState, ActionCreator[]>[] = [
  on(loadRecommendations, (state) => ({
    ...state,
  })),
  on(loadRecommendationsSuccess, (state, { cropId, recommendations }) => {
    const cropDetail = state.entities[`${cropId}`]
    if (cropDetail) {
      const updatedParent: CropDetailActivities = {
        ...cropDetail,
        recommendations: [...recommendations],
      }

      return cropDetailAdapter.updateOne({ id: cropId, changes: updatedParent }, state)
    }

    return state
  }),
  on(loadRecommendationsFailure, (state) => ({
    ...state,
  })),
  on(addRecommendation, (state) => ({
    ...state,
  })),
  on(addRecommendationSuccess, (state, { payload: { recommendations } }) => {
    // Multi-reco sends every created recommendation in one action, and two of them can land on
    // the same crop — accumulate per crop so nothing is dropped.
    const updatedCrops = new Map<number, CropDetailActivities>()
    for (const recommendation of recommendations) {
      for (const crop of recommendation.crops ?? []) {
        const cropDetail = updatedCrops.get(crop.id) ?? state.entities[`${crop.id}`]
        if (cropDetail) {
          updatedCrops.set(crop.id, {
            ...cropDetail,
            recommendations: [...(cropDetail.recommendations || []), recommendation],
          })
        }
      }
    }

    if (!updatedCrops.size) {
      return state
    }

    return cropDetailAdapter.updateMany(
      [...updatedCrops.values()].map((v) => ({ id: v.cropId, changes: v })),
      state,
    )
  }),
  on(addRecommendationFailure, (state) => ({
    ...state,
    error: 'Recommendation has not  been added ...',
  })),
  on(addRecommendations, (state) => ({
    ...state,
  })),
  on(addRecommendationsFailure, (state) => ({
    ...state,
    error: 'Oups, Recommendations has not  been added ...',
  })),
  on(deleteRecommendation, (state) => ({
    ...state,
  })),

  on(deleteRecommendationSuccess, (state, { cropId, recommendationId }) => {
    const cropDetail = state.entities[`${cropId}`]
    if (cropDetail) {
      const updatedParent: CropDetailActivities = {
        ...cropDetail,
        recommendations: (cropDetail.recommendations || []).filter((reco) => reco.id !== recommendationId),
      }

      return cropDetailAdapter.updateOne({ id: cropId, changes: updatedParent }, state)
    }

    return state
  }),
  on(deleteRecommendationError, (state) => ({
    ...state,
    error: 'Oups, Recommendation has not  been deleted ...',
  })),
]
